import { PayloadAction } from '@reduxjs/toolkit';

import { AddonsState } from 'editor/src/store/editorModules/addons/types';

const removeAddonInUseReducer = (state: AddonsState, action: PayloadAction<string>) => {
  state.inUse = state.inUse.filter((addon) => addon.id !== action.payload);
};

export default removeAddonInUseReducer;
